// extracted by mini-css-extract-plugin
export var cardHeader = "_tn-0";
export var reorderHandle = "_tn-3";
export var titleArea = "_tn-1";
export var titleAreaWithHandle = "_tn-2";